// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"2901b280","299":"ffbcb619","334":"98a311a8","383":"0ded19e3","453":"da6c9c3a","489":"dd915994","609":"1deef3af","764":"3b6145f1","859":"082a294c","945":"2a2185f1"}[chunkId] + ".chunk.js";
};